/**
 * Sorts seat options by their index and returns an array of entries
 * @param {Object} seatOptions - The seat options object
 * @returns {Array} Sorted array of [key, value] entries
 */
export const sortSeatOptionsByIndex = (seatOptions) => Object
  .entries(seatOptions)
  .sort(([, a], [, b]) => (a.index ?? 0) - (b.index ?? 0));

/**
 * Converts sorted seat options entries back to an object while maintaining order
 * @param {Array} sortedEntries - Array of [key, value] entries
 * @returns {Object} Ordered seat options object
 */
export const entriesToOrderedObject = (sortedEntries) => sortedEntries
  .reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
